export const EMAIL_FIELD_NAME = 'email';

export const FIRST_NAME_FIELD_NAME = 'firstName';

export const LAST_NAME_FIELD_NAME = 'lastName';

export const PHONE_FIELD_NAME = 'phone';

export const TEST_ID = 'updateUserForm';
